const RadioButton = ({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: () => void;
}) => (
  <label
    className="flex items-center gap-[var(--spacing-sm)]"
    style={{ font: "var(--font-bodyStd)", cursor: "pointer" }}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      aria-label={label}
      style={{
        appearance: "none",
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        border: checked
          ? "5px solid var(--col-interaction-tertiary)"
          : "2px solid var(--col-border-primary)",
        cursor: "pointer",
        transition: "border 0.15s ease",
        flexShrink: 0,
      }}
    />
    {label}
  </label>
);

export default RadioButton;
